var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExperiences(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0e9941",
    d: "M13.28 12.749a1.421 1.421 0 0 1-1.378-1.765l.6-2.397-1.246-1.192a1.42 1.42 0 0 1 1.003-2.424h1.692l.744-1.86a1.419 1.419 0 0 1 2.61 0l.818 1.909 1.618-.049a1.42 1.42 0 0 1 1.003 2.424l-1.266 1.268.62 2.32a1.42 1.42 0 0 1-2.083 1.578l-2.055-1.175-1.976 1.175a1.417 1.417 0 0 1-.704.188zm-.827-6.278 1.13 1.132a1.424 1.424 0 0 1 .374 1.347l-.554 2.216 1.893-1.082a1.425 1.425 0 0 1 1.408 0l1.893 1.082-.554-2.215a1.427 1.427 0 0 1 .376-1.35l1.128-1.13h-1.498a1.416 1.416 0 0 1-1.305-.861L16 3.875l-.744 1.735a1.417 1.417 0 0 1-1.305.861zM23.453 14.749a1.271 1.271 0 0 1-1.232-1.58l.434-1.738-.894-.895a1.271 1.271 0 0 1 .898-2.17h1.165l.576-1.345a1.27 1.27 0 0 1 1.168-.77h.002a1.266 1.266 0 0 1 1.166.771l.578 1.344h1.165a1.271 1.271 0 0 1 .898 2.17l-.895.895.435 1.739a1.27 1.27 0 0 1-1.863 1.41l-1.486-.847-1.484.848a1.27 1.27 0 0 1-.63.168zm-.241-4.883.595.596a1.275 1.275 0 0 1 .335 1.205l-.336 1.345 1.133-.647a1.275 1.275 0 0 1 1.261 0l1.132.647-.336-1.344a1.278 1.278 0 0 1 .333-1.205l.597-.597h-.764a1.268 1.268 0 0 1-1.168-.77l-.426-.993-.424.993a1.27 1.27 0 0 1-1.17.77zm-.466 1.657h.001zM8.516 14.632a1.269 1.269 0 0 1-.631-.167l-1.486-.85-1.484.85a1.27 1.27 0 0 1-1.863-1.412l.434-1.739-.894-.894a1.271 1.271 0 0 1 .898-2.17h1.165l.576-1.346a1.271 1.271 0 0 1 2.337 0l.577 1.346H9.31a1.271 1.271 0 0 1 .898 2.17l-.895.895.435 1.738a1.27 1.27 0 0 1-1.232 1.58zM4.043 9.75l.596.595a1.284 1.284 0 0 1 .335 1.206l-.337 1.345 1.133-.647a1.274 1.274 0 0 1 1.26-.001l1.133.647-.336-1.343a1.28 1.28 0 0 1 .335-1.207l.595-.595h-.764a1.268 1.268 0 0 1-1.168-.771L6.4 7.986l-.425.993a1.269 1.269 0 0 1-1.168.771z",
    opacity: 1,
    "data-original": "#7fbde7",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#232323"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.282 28.25H13a.75.75 0 0 1 0-1.5h7.282a3.256 3.256 0 0 0 2.095-.765l5.612-4.73a1.424 1.424 0 0 0-.28-2.362 1.42 1.42 0 0 0-1.347.04L20.3 22.417a4.764 4.764 0 0 1-2.368.632h-3.753a.75.75 0 1 1 0-1.5h3.753a3.251 3.251 0 0 0 1.62-.433l6.062-3.486a2.925 2.925 0 0 1 3.342 4.772l-5.612 4.73a4.761 4.761 0 0 1-3.062 1.117z",
    fill: "#112d55",
    opacity: 1,
    "data-original": "#232323",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 27.5,
    r: 0.75,
    fill: "#112d55",
    opacity: 1,
    "data-original": "#232323",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 27.25a.75.75 0 0 1-.75-.75v-7A1.752 1.752 0 0 1 10 17.75h4.446a2.75 2.75 0 0 1 2.75 2.822l-.046 1.747a.75.75 0 0 1-.75.73h-.02a.75.75 0 0 1-.73-.769l.046-1.747a1.25 1.25 0 0 0-1.25-1.283H10a.25.25 0 0 0-.25.25v7a.75.75 0 0 1-.75.75z",
    fill: "#112d55",
    opacity: 1,
    "data-original": "#232323",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 29.75H4A1.752 1.752 0 0 1 2.25 28V18A1.752 1.752 0 0 1 4 16.25h4A1.752 1.752 0 0 1 9.75 18v10A1.752 1.752 0 0 1 8 29.75zm-4-12a.25.25 0 0 0-.25.25v10a.25.25 0 0 0 .25.25h4a.25.25 0 0 0 .25-.25V18a.25.25 0 0 0-.25-.25z",
    fill: "#112d55",
    opacity: 1,
    "data-original": "#232323",
    className: ""
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperiences);
export default __webpack_public_path__ + "static/media/experiences.b92159583732d6c2447dac56e76b1023.svg";
export { ForwardRef as ReactComponent };